// ProductBanner.jsx
import React from 'react';
import { Image_URL } from '../../../config/config';
import './ProductShowcase.css';

const ProductBanner = ({ banners }) => {
  if (!banners || banners.length === 0) {
    return <div className="banner-wrapper">No banners available.</div>;
  }

  return (
    <div className="banner-wrapper">
      <div className="container">
        <div className="banner-row">
          {/* Left Column - Large Image */}
          {banners[0] && (
            <div className="banner-col-large">
              <a href="http://localhost:3000/product-list" className="banner-link">
                <div className="banner-container banner-container-large">
                  <img
                    src={`${Image_URL}home-images/thumbnails/${banners[0].ImagePath}`}
                    alt="Banner 1"
                    className="banner-image"
                  />
                  <div className="banner-text">
                    <p>{banners[0].SectionName || "Section Name"}</p>
                    <button className="shop-now-btn">Shop Now</button>
                  </div>
                </div>
              </a>
            </div>
          )}

          {/* Right Column - Stacked Images */}
          <div className="banner-col-small">
            {banners[1] && (
              <div className="banner-small-container">
                <a href={banners[1].Url} className="banner-link">
                  <div className="banner-container banner-container-small">
                    <img
                      src={`${Image_URL}home-images/thumbnails/${banners[1].ImagePath}`}
                      alt="Banner 2"
                      className="banner-image"
                    />
                    <div className="banner-text">
                      <p>{banners[1].SectionName || "Section Name"}</p>
                      <button className="shop-now-btn">Shop Now</button>
                    </div>
                  </div>
                </a>
              </div>
            )}

            {banners[2] && (
              <div className="banner-small-container">
                <a href={banners[2].Url} className="banner-link">
                  <div className="banner-container banner-container-small">
                    <img
                      src={`${Image_URL}home-images/thumbnails/${banners[2].ImagePath}`}
                      alt="Banner 3"
                      className="banner-image"
                    />
                    <div className="banner-text">
                      <p>{banners[2].SectionName || "Section Name"}</p>
                      <button className="shop-now-btn">Shop Now</button>
                    </div>
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductBanner;